import React from 'react';
import PropTypes from 'prop-types';
// Custom
import { DisabledContext } from 'components/misc/Contexts';
import ItemsSelectField from 'components/inputFields/ItemsSelectField';
import { CloseIconButton } from 'components/buttons/IconButtons';

const ItemsSelectFieldFilter = ({
  labelId, value, items, onChange,
}) => (
  <DisabledContext.Consumer>
    {(disabled) => (
      <ItemsSelectField
        disabled={disabled}
        labelId={labelId}
        value={value}
        items={items}
        withNullItem
        hideDropDownIcon={value !== null}
        adornments={{
          end: value !== null ? (
            <CloseIconButton onClick={() => onChange(null)} tooltipId="tooltip.empty" />) : null,
        }}
        onChange={onChange}
      />
    )}
  </DisabledContext.Consumer>
);

ItemsSelectFieldFilter.propTypes = {
  labelId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
    labelId: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
};

ItemsSelectFieldFilter.defaultProps = {
  value: null,
};

module.exports = ItemsSelectFieldFilter;



// WEBPACK FOOTER //
// ./components/filters/ItemsSelectFieldFilter.js